import { Pipe, PipeTransform } from '@angular/core';

import { RdsChip } from '../chips/index';
import { RdsNumericFilter } from './numeric-filter.model';

/**
 * Turn `RdsNumericFilter` into RdsChips
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Pipe({
  name: 'rdsFiltersToChips'
})
export class RdsFiltersToChipsPipe implements PipeTransform {
  transform(value: Array<RdsNumericFilter>): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return value.map(f => new RdsChip(f.operation.type + ' ' + f.value, f.operation.type + f.value));
  }
}
